import React, { Component } from 'react';
import ViewButton from './_ViewButton'

const styles = {
  ulStyle: {
    boxSizing: 'border-box',
    listStyleType: 'none',
    margin: '0',
    padding: '0',
    overflow: 'hidden',
    position: 'fixed',
    top: '0',
    width: '100%',
    borderTopLeftRadius: '5px',
    borderTopRightRadius: '5px',
    border: '1px solid grey',
    zIndex: '120',
    backgroundColor: 'white',
  },
  liLeftStyle: {
    float: 'left'
  },
  liRightStyle: {
    float: 'right'
  },
  brandContentStyle: {
    float: 'left',
  },
  brandImgStyle: {
    float: 'left',
    margin: '-2px 5px 0 -3px'
  },
  whitenerStyle: {
    backgroundColor: 'white',
    position: 'fixed',
    top: '0',
    width: '100%',
    height: '30px',
    zIndex: '80',
  }
}

class _EmbedHeaderComponent extends Component {
  constructor() {
    super()
    this.state = {
      hovered: ""
    }
  }
  render() {
    const { ulStyle, liLeftStyle, liRightStyle, brandContentStyle,
            brandImgStyle, whitenerStyle } = styles;
    return (
      <div>
        <ul style={ulStyle}>
          <li style={liLeftStyle}>
            <ViewButton
              onClick={() => this.props.navigateToEditPage()}
              active={false}>
              <img style={brandImgStyle} src="/envelopeLogoRed.png" alt="" height="20"></img>
              <div style={brandContentStyle} >Edit on Envelope</div>
            </ViewButton>
          </li>
          {this.props.mobile ? null : (
            <li style={liRightStyle}>
              <ViewButton
                active={true}>Result</ViewButton>
            </li>
          )}
          {this.props.mobile ? null : (
            <li style={liRightStyle}>
              <ViewButton
                onClick={() => this.props.buttonClick("data")}
                active={this.props.active === "data"}>Data</ViewButton>
            </li>
          )}
        </ul>
        <div style={whitenerStyle}></div>
      </div>
    );
  }
}

export default _EmbedHeaderComponent;



// WEBPACK FOOTER //
// ./src/_EmbedHeaderComponent.js